import useAppliedProfilesToVacancies from './useAppliedProfilesToVacancies';

export const useIsUserAppliedForAnyVacancies = (profileId: string) => {
  const allAppliedToVacanciesIDs = useAppliedProfilesToVacancies();
  return allAppliedToVacanciesIDs.includes(profileId);
};
